import DocumentsView from './DocumentsView';
export default DocumentsView;
